<template>
    <!-- 赎货流水 -->
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <div class="search_time search_inputBox">
                <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                ~
                <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
            </div>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.issuing_id" placeholder="开证公司" @visible-change="getSelectList('redeemBillIssuing')">
                <el-option v-for="(list,index) in selectMap.redeemBillIssuing" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.contract_no" placeholder="融资合同号"></el-input>
            <el-input class="search_input search_inputBox" v-model="params.finance_order_sn" placeholder="融资提单号"></el-input>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.payer_id" placeholder="付款人" @visible-change="getSelectList('redeemBillPayer')">
                <el-option v-for="(list,index) in selectMap.redeemBillPayer" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.bill_type" placeholder="流水类型" @visible-change="getSelectList('redeemBillType')">
                <el-option v-for="(list,index) in selectMap.redeemBillType" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" multiple collapse-tags v-model="params.redeem_type" placeholder="单据类型" @visible-change="getSelectList('redeemBillOrder')">
                <el-option v-for="(list,index) in selectMap.redeemBillOrder" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-model="params.remark" placeholder="备注"></el-input>
            <div class="searchBtnList clearfix">
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
             <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="btnList clearfix">
            <el-button class="funcPublicBtn funcPublicBtnChecked" :disabled="isDelete" @click="batchDel">删除</el-button>
        </div>
        <div class="tableBox">
            <tabletem :isShowIndex="true" :isSetCol="true" scene="purchase.redeem.bill" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber">合计：</div>
            <div class="totalNumber">已赎方数:{{tot.redeem_cube}}m³</div>
            <div class="totalNumber">实付金额:{{tot.amount}}</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" :isGlobal="isGlobal" scene="purchase.redeem.bill" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<script>
    import bus from "../../../../eventBus";
    import tabletem from '../../../../components/table.vue';
    import pagination from '../../../../components/pagination.vue';
    export default {
        data(){
            return {
                module: localStorage.dw_erp_power_code,
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    issuing_id:"",
                    payer_id:'',
                    contract_no:"",
                    finance_order_sn:'',
                    bill_type:'',
                    redeem_type:'',
                    remark:'',
                },
                last_page:1,
                total:0,
                tot:{},
                fields:"",
                filter:"",
                filters: [],
                filterDialogVisible:false,
                isGlobal:false,
                tableLoading:false,
                selectRow:[],
                tableCol:[
                    {colName:"流水日期",colKey:"bill_time",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"开证公司",colKey:"issuing",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"融资合同号",colKey:"contract_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"融资提单号",colKey:"finance_order_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"已赎方数",colKey:"redeem_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"实付金额",colKey:"amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款人",colKey:"payer",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,},
                    {colName:"流水类型",colKey:"bill_type_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"单据类型",colKey:"redeem_type_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款账户",colKey:"account_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"流水单号",colKey:"bill_sn",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                ],
                list:[],
                selectMap:{
                    redeemBillIssuing:[],
                    redeemBillType:[],
                    redeemBillOrder:[],
                    redeemBillPayer:[]
                },
                contract_no:'',
                isDelete:true,
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getSelectList('redeemBillType');
            this.getSelectList('redeemBillOrder');
            this.getSelectList('redeemBillPayer');
            this.getSelectList('redeemBillIssuing');
            this.contract_no = sessionStorage.getItem("STORE_CONTRACT_NO")
            sessionStorage.removeItem("STORE_CONTRACT_NO")
            if(this.contract_no){
                this.params.contract_no =String(this.contract_no);
            }
            this.getList();
            // this.getSelectList('advstatus');
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            getList(){
                this.tableLoading = true;
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.$postColumnList("/erp/purchase.redeem.bill",this.params,res=>{
                    this.last_page=parseInt(res.data.data.list.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.list.total);
                    // this.balance = res.data.data.issuing_balance;
                    this.tot= res.data.data.total;
                    this.list=res.data.data.list.data;
                    let obj ={
                        sales_count:res.data.data.sales_count,
                        advance_count:res.data.data.advance_count
                    }
                    this.$emit('child-num',obj)
                    this.list.forEach((item,index)=>{
                        item.baseColor = "";
                        this.list[index].bill_time = this.formatTime(item.bill_time+"000")
                        // if(item.status_text=='待付款'){
                        //     item.baseColor='red';
                        // }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        if(item.colKey=="status_text"){
                            if(this.fields.indexOf(",status,")!=-1){
                                item.isShow=true;
                            }
                        }
                    })
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.start_time="";
                this.end_time="";
                this.getList();
            },
            selectionDetailChange(row){
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                if(row.isSelect==1){
                    this.$refs.outBoundDetailTable.toggleRowSelection(row);
                }else{
                    return false;
                }
            },
            getRow(row){
                const isDelete = row.every(item => item.is_delete === 1);
                this.isDelete = !isDelete;
                this.selectRow=row;
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.filters = [];
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                    this.filters = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                this.scene = 'redeem.advance.column';
                this.isGlobal = true;
                this.getBillColumn();
                if(obj.name =='redeem_order_sn'){
                    this.dialogVisible = true;
                    this.postFunc('/erp/advance.redeem.info',{id:obj.id},res=>{
                        this.form_params = res.data.data;
                        this.form_paramstot = this.form_params.total;
                        this.issuing_balance = this.form_params.issuing_balance;
                        this.add_params.pay_amount = this.form_paramstot.payable_amount;
                        this.form_params.redeem_date = this.formatTime(this.form_params.redeem_date+"000");
                        this.listDetail = this.form_params.details;
                    })
                }
            },
            //删除
            batchDel(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.$confirm('是否删除?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let arr = new Array();
                        this.selectRow.forEach(item=>{
                            arr.push(item.id)
                        })
                        this.postFunc("/erp/purchase.redeem.bill.delete",{ids:arr},()=>{
                            this.tip("删除成功","success")
                            this.getList();
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }).catch(()=>{});
                }
            },
            excelExport(){
                this.$exportExecl("/erp/purchase.redeem.bill.export","赎货流水",this.params)
            },
            //合计
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube:4,
                    redeem_amount:2,
                },total=>{
                });
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{

        }
    }
</script>
<style  scoped lang="scss">
.btnBox{
    display: flex;
    .payBtnDiv{
        padding: 5px 20px 10px 0;display: inline-block;border-right: 2px solid #eee;
    }
    .balanceDiv{
        display: inline-block;
        .banCheckboxGroup{
            display: flex;
            margin-left: 20px;
        }
        .balanceItem{
            margin-left: 20px;
            line-height: 24px;
            font-weight: 600;
            font-size: 14px;
            margin-top: 7px;
            .balanceIcon{
                position: relative;
                top: 5px;
                margin-right: 1px;
            }
            .balanceImg{
                width: 20px;
                height: 19px;
                position: relative;
                top: 5px;
                margin-right: 5px;
            }
            /*重写radio样式*/
            /deep/ .el-radio__inner{
                width: 20px;
                height: 20px;
                border-radius: 2px;
            }
            /deep/ .el-radio__input.is-checked .el-radio__inner:after{
                width: 6px;
                height: 13px;
                box-sizing: content-box;
                border: 1px solid #fff;
                border-left: 0;
                border-top: 0;
                left: 6px;
                position: absolute;
                border-radius: 2px;
                transform-origin: center;
                transform: rotate(45deg);
                background: none;
                top: 0;
            }
        }
    }
}
.editBtnList{padding:10px;
    .editTax{float: left;margin-right:20px;}
    .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
    .editTaxinput{float: left;width:100px;}
    .editBtn{float: right;}
}
</style>